<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({ name: 'edit_plan', params: { id: 'new' } })">
        افزودن
        <i class="fas fa-plus" />
      </button>
      <hr>
    </div>
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو اشتراک
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="search">
              <label for="title" class="text-right mb-1">عنوان</label>
              <input id="title" v-model="filters.title" type="text" class="fv-sm form-control" placeholder="عنوان">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="is_enabled" class="text-right mb-1">فعال</label>
              <fv-switch id="is_enabled" class="d-block" placeholder="فعال" v-model="filters.enabled" />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="is_view_enabled" class="text-right mb-1">قابل نمایش</label>
              <fv-switch id="is_view_enabled" class="d-block" placeholder="قابل نمایش" v-model="filters.view" />
            </div>
          </div>
          <div class="col-12 text-left">
            <button @click.prevent="search" class="btn btn-info">
              جستجو
              <i class="fas fa-search" />
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">
        <template slot="field-#" , slot-scope="scope">
          <span>{{ scope.index + 1 + ((page - 1) * (pagination.page === 1 ? 0 : pagination.per_page)) }}</span>
        </template>
        <template slot="field-عنوان" slot-scope="scope">
          {{ scope.row.title || '---' }}
        </template>
        <template slot="field-تعداد روزها" slot-scope="scope">
          <div>{{ scope.row.days_count || '---' }} </div>
        </template>
        <template slot="field-قیمت" slot-scope="scope">
          <div>{{ `${$priceMask(scope.row.price)} ` || '---' }} </div>
        </template>
        <template slot="field-واحد پول" slot-scope="scope">
          <div>{{ scope.row.currency || 'ریال' }} </div>
        </template>
        <template slot="field-درصد تخفیف" slot-scope="scope">
          <div>{{ scope.row.discount_percent || '---' }} </div>
        </template>
        <template slot="field-درصد مالیات" slot-scope="scope">
          <div>{{ scope.row.tax_pct || '---' }} </div>
        </template>
        <template slot="field-قیمت با تخفیف" slot-scope="scope">
          <div>{{ scope.row.discount_price || '---' }} </div>
        </template>
        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{ $dateTimeFormat(scope.row.created_at) }}
        </template>
        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({ name: 'edit_plan', params: { id: scope.row.id } })"
            class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit" />
          </button>
        </template>
      </fvTable>

    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search" />
    </div>

  </div>
</template>
<script>

import { mapActions } from "vuex"
import appUserSelect from "../../components/appUserSelect";
import appGendersSelect from "../../components/appGendersSelect";
import appCategorySelect from "../../components/appCategorySelect";
import appPagination from "../../components/appPagination";

export default {
  name: 'plans',
  data() {
    const { query } = this.$route
    const { page, filters, sort } = query;
    const filtersObj = filters ? JSON.parse(filters) : {}
    return {
      ...mapActions('main', [
        'crud'
      ]),
      item: [],
      fields: ['#', 'عنوان', 'تعداد روزها', 'قیمت', 'واحد پول', 'درصد مالیات', 'درصد تخفیف', 'قیمت با تخفیف', 'تاریخ ثبت', 'actions'],
      query,
      filters: filtersObj,
      sort: sort || '-_score,-created_at',
      page: parseInt(page) || 1,
      pagination: {}
    }
  },
  components: {
    appPagination,
    appUserSelect,
    appGendersSelect,
    appCategorySelect
  },
  methods: {
    async getData() {
      this.$store.commit('main/SET', { key: 'loading', value: true })
      try {
        const apiFilters = await this.$generateFilter(this.filters)
        const item = await this.crud({
          action: 'get',
          section: 'plans',
          query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`
        })
        if (item.data && item.data.items) {
          const result = item.data.items
          this.item = result
          this.pagination = item.data.pagination
        }
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit('main/SET', { key: 'loading', value: false })
      }
    },
    async search() {
      this.filters = await this.$validateFilter(this.filters)
      await this.$router.push({
        query: {
          filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
          sort: this.sort || undefined,
          page: this.page
        }
      })
    },
  },

  async created() {
    await this.getData()
  },
  watch: {
    '$route.query'() {
      this.getData();
    }
  },

  // beforeUpdate() {
  // }
};
</script>
<style></style>
